export const booleanStatesConstants = {
    UPDATE_IS_UPLOADED: "UPDATE_IS_UPLOADED",
    UPDATE_IS_AMOUNT_FILL: "UPDATE_IS_AMOUNT_FILL",
    UPDATE_IS_UPLOADED_DIS_FILE: "UPDATE_IS_UPLOADED_DIS_FILE",
    UPDATE_IS_AMOUNT_FILL_DIS_FILE: "UPDATE_IS_AMOUNT_FILL_DIS_FILE",
    UPDATE_IS_UPLOADED_ROOM_IMAGES:"UPDATE_IS_UPLOADED_ROOM_IMAGES"
  };
  